import { render, staticRenderFns } from "./out-of-stock-notification.vue?vue&type=template&id=09136366&scoped=true"
import script from "./out-of-stock-notification.vue?vue&type=script&lang=js"
export * from "./out-of-stock-notification.vue?vue&type=script&lang=js"
import style0 from "./out-of-stock-notification.vue?vue&type=style&index=0&id=09136366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09136366",
  null
  
)

export default component.exports